import * as localStorage from '@/services/localStorage';

const searchHistoryLocalStorageItem = 'nikeSearchHistory';
export function addSearchTextToHistory(searchText) {
    let searchHistory = getSearchTextHistory();
    const index = searchHistory.indexOf(searchText);
    if (index > -1) {
        searchHistory.splice(index, 1);
    }
    searchHistory.unshift(searchText);
    localStorage.setObject(searchHistoryLocalStorageItem, searchHistory);
}
export function getSearchTextHistory() {
    return localStorage.getObject(searchHistoryLocalStorageItem) || [];
}
export function removeSearchTextHistory(value) {
    let searchHistory = getSearchTextHistory();
    searchHistory.splice(searchHistory.indexOf(value), 1);
    localStorage.setObject(searchHistoryLocalStorageItem, searchHistory);
}
export function clearSearchTextHistory() {
    localStorage.removeKey(searchHistoryLocalStorageItem);
}
